import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, { scheduleId }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const userLoginInfoResult = await fetch(
      `${URI_TARIFF_PLAN}relate-tariff-schedule/user/${scheduleId}`,
      opts,
    );
    const resultJson = await userLoginInfoResult.json();

    if (userLoginInfoResult.status !== 200) {
      return Promise.reject(resultJson);
    }

    return resultJson;
  } catch (error) {
    return Promise.reject(error);
  }
};
